"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ourToast = void 0;
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importDefault(require("react"));
var react_toastify_1 = require("react-toastify");
function ourToast(props) {
    var content = props.content, _a = props.autoClose, autoClose = _a === void 0 ? 5000 : _a, onClick = props.onClick;
    (0, react_toastify_1.toast)(react_1.default.createElement("div", { className: "bg-white p-4", onClick: function (e) {
            e.stopPropagation();
            if (onClick) {
                onClick();
            }
            react_toastify_1.toast.dismiss();
        } }, content), {
        closeButton: (react_1.default.createElement("div", { className: "absolute right-0 top-0 flex justify-center items-center h-full pr-1" },
            react_1.default.createElement("div", { className: "w-8 h-8 text-lg bg-primary flex flex-row justify-center items-center rounded-full text-white" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes })))),
        className: "p-0 ",
        autoClose: autoClose,
        bodyClassName: "p-0",
        position: "top-center",
    });
}
exports.ourToast = ourToast;
